/**
 * Welcome modal for first-time visitors
 * Shows a brief introduction to the site and how to use it
 */

document.addEventListener('DOMContentLoaded', () => {
	// Check if this is the first visit
	if (!localStorage.getItem('hasVisitedBefore')) {
		showWelcomeModal();
		// Set flag in local storage
		localStorage.setItem('hasVisitedBefore', 'true');
	}
});

function showWelcomeModal() {
	const previouslyFocused = document.activeElement;
	const modal = document.createElement('div');
	modal.className = 'modal welcome-modal visible';
	modal.setAttribute('role', 'dialog');
	modal.setAttribute('aria-modal', 'true');
	modal.setAttribute('aria-labelledby', 'welcome-title');
	modal.setAttribute('aria-describedby', 'welcome-description');

	// Ensure the modal content is visible by adjusting to viewport height
	const viewportHeight = window.innerHeight;

	modal.innerHTML = `
        <div class="modal-content welcome-content">
			<button class="modal-close close-button" type="button" aria-label="Close welcome dialog"><i class="fas fa-times" aria-hidden="true"></i></button>
            <div class="welcome-header">
				<img src="/icons/180-nobo.png" alt="" aria-hidden="true" width="80" height="80" class="welcome-logo rounded-icon">
				<h2 id="welcome-title">Florida's Scenic Byways</h2>
            </div>
			<div class="modal-message" id="welcome-description">
                Discover Florida's most beautiful drives and roadside attractions.
            </div>
            <div class="welcome-features">
                <div class="welcome-feature">
                    <div class="feature-icon"><i class="fas fa-road"></i></div>
                    <div class="feature-text">
                        <h4>Colorful Routes</h4>
                        <p>Each byway is highlighted with its own unique color on the map</p>
                    </div>
                </div>
                <div class="welcome-feature">
                    <div class="feature-icon"><i class="fas fa-search"></i></div>
                    <div class="feature-text">
                        <h4>Easy Search</h4>
                        <p>Find byways by name or explore what's nearby</p>
                    </div>
                </div>
                <div class="welcome-feature">
                    <div class="feature-icon"><i class="fas fa-location-crosshairs"></i></div>
                    <div class="feature-text">
                        <h4>Nearby Exploration</h4>
                        <p>Use the location button to find byways close to you</p>
                    </div>
                </div>
            </div>
			<button class="welcome-start-btn" type="button">Start Exploring</button>
            <p class="welcome-attribution">Inspired by the official <a href="/files/Florida-Scenic-Highways-Brochure_01-24.pdf" target="_blank" rel="noopener">Florida Scenic Highways Brochure <i class="fas fa-file-pdf" aria-hidden="true"></i></a></p>
        </div>
    `;

	document.body.appendChild(modal);

	// Close button functionality
	const closeBtn = modal.querySelector('.modal-close');
	const startBtn = modal.querySelector('.welcome-start-btn');

	function closeModal() {
		document.removeEventListener('keydown', handleKeydown);
		modal.classList.remove('visible');
		setTimeout(() => {
			modal.remove();
			if (previouslyFocused instanceof HTMLElement) {
				previouslyFocused.focus();
			}
		}, 300);
	}

	function handleKeydown(event) {
		if (event.key === 'Escape') {
			closeModal();
			return;
		}

		if (event.key !== 'Tab') return;

		const focusable = Array.from(modal.querySelectorAll('a[href], button:not([disabled])'));
		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault();
			last.focus();
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault();
			first.focus();
		}
	}

	closeBtn.addEventListener('click', closeModal);
	startBtn.addEventListener('click', closeModal);
	document.addEventListener('keydown', handleKeydown);
	closeBtn.focus();

	// Ensure the modal is scrollable if content exceeds viewport height
	const modalContent = modal.querySelector('.modal-content');
	if (modalContent.offsetHeight > viewportHeight * 0.9) {
		modalContent.style.height = Math.max(viewportHeight * 0.85, 400) + 'px';
		modalContent.style.overflowY = 'auto';
	}
}
